export default "__VITE_ASSET__893e9778__"